import React from "react"
import FileDownloads from "../components/resources/file-downloads/file-downloads";
import useDownloads from "../hooks/useDownloads";

const Download = ({ pageContext, location }) => {
  const downloads = useDownloads().filter(dl => pageContext.downloads.includes(dl.id));

  return <div className="_fp-global-container" style={{marginBlock: "2rem 8rem"}}>
    <h2 className={"_fp-heading-2"}></h2>
    <FileDownloads downloads={downloads} fullWidth={true} fileStyle={"white"}></FileDownloads>
  </div>
}

export default Download
